<app-user-dashboard [fullScreen]="true">
  <div class="bg-container" id="virtual-comex">
    <div class="container">
      <div class="column-info fade-in-up-js">
        <h1 class="title fade-in fade-in-delay">{{'InternationalMarketplace.Title' | translate}}</h1>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-2">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'InternationalMarketplace.Subtitle1' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-3">
            {{'InternationalMarketplace.Text1Part1' | translate}} <strong style="font-weight:600">{{'InternationalMarketplace.Text1Part2' | translate}}.</strong>
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-4">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'InternationalMarketplace.Subtitle2' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-5">
            {{'InternationalMarketplace.Text2Part1' | translate}} <strong style="font-weight:600">{{'InternationalMarketplace.Text2Part2' | translate}} </strong>{{'InternationalMarketplace.Text2Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-6">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'InternationalMarketplace.Subtitle3' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-8">
            {{'InternationalMarketplace.Text3Part1' | translate}} <strong style="font-weight:600">{{'InternationalMarketplace.Text3Part2' | translate}}.</strong>
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-9">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'InternationalMarketplace.Subtitle4' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-10">
            {{'InternationalMarketplace.Text4Part1' | translate}} <strong style="font-weight:600">{{'InternationalMarketplace.Text4Part2' | translate}} </strong>{{'InternationalMarketplace.Text4Part3' | translate}}.
          </p>
        </div>
        <div class="container-row">
          <div class="container-subtitle fade-in fade-in-delay-11">
            <i class="figure-circle"></i>
            <h3 class="subtitle-main">
              {{'InternationalMarketplace.Subtitle5' | translate}}
            </h3>
          </div>
          <p class="text-info fade-in fade-in-delay-12">
            {{'InternationalMarketplace.Text5Part1' | translate}} <strong style="font-weight:600">{{'InternationalMarketplace.Text5Part2' | translate}} </strong>{{'InternationalMarketplace.Text5Part3' | translate}}.
          </p>
        </div>
      </div>

      <div class="column-img fade-in-left-js only-desktop">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/marketplace.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

      <div class="column-img fade-in-right-js only-mobile">
        <figure class="figure-img">
          <img src="../../../../assets/img/to_do_fruzty/marketplace.png" style="width: 80%" alt="flag"/>
        </figure>
      </div>

    </div>
  </div>

</app-user-dashboard>

<app-footer-home></app-footer-home>
